import React from "react";
import { useCart } from "./CartContext";
import { useNavigate } from "react-router-dom";

const FloatingCartButton = () => {
  const { cart } = useCart();
  const cartCount = cart.reduce((acc, item) => acc + item.quantity, 0);
  const navigate = useNavigate();

  if (cartCount === 0) return null;

  return (
    <button
      aria-label="View cart"
      onClick={() => navigate('/checkout')}
      style={{
        position: "fixed",
        bottom: 58,           // Move up and shrink
        right: 13,
        zIndex: 1301,
        background: "#d4c4a8",
        color: "#181308",
        border: "none",
        borderRadius: 30,
        boxShadow: "0 3px 12px #22190b18",
        padding: "0.69rem 1rem 0.69rem 0.78rem",
        fontSize: "1rem",
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        gap: 7,
        cursor: "pointer",
        minHeight: 0,
        minWidth: 0,
        transition: "background 0.18s, box-shadow 0.17s"
      }}
      onMouseOver={e => (e.currentTarget.style.background = "#cab27c")}
      onMouseOut={e => (e.currentTarget.style.background = "#d4c4a8")}
      className="shadow"
    >
      <i className="bi bi-cart" style={{ fontSize: "1.18rem", marginRight: 2 }}/>
      <span style={{
        background: "#bfa66a",
        color: "#fff",
        borderRadius: 18,
        fontSize: "0.98rem",
        minWidth: 18,
        textAlign: "center",
        padding: "2.5px 7px",
        fontWeight: 700,
        marginLeft: 0.5
      }}>
        {cartCount}
      </span>
    </button>
  );
};

export default FloatingCartButton;
